import { DatabaseRecord } from "../repos/table.repo";

export interface PaymentPointModel extends DatabaseRecord {
    name: string;
    address: string;
    phone?: string;
    provinceId?: string;
    districtId?: string;
    wardId?: string;
    latitude?: number;
    longtitude?: number;
    status: string;
    waterFactoryId: string;
    description?: string;
    workingHours?: string;
    createdAt?: string;
    updatedAt?: string;
    createdBy?: string;
    updatedBy?: string;
}

export class PaymentPointModelFactory {
    static getEmpty(): PaymentPointModel {
        return {
            id: "",
            name: "",
            address: "",
            phone: "",
            provinceId: "",
            districtId: "",
            wardId: "",
            latitude: undefined,
            longtitude: undefined,
            status: "",
            waterFactoryId: "",
            description: "",
            workingHours: "",
            createdBy: "",
            updatedBy: ""
        };
    }
}

